import {
  PaymentOptionApiModel,
  PaymentOptionOptionApiModel,
  PaymentOptionType,
  VerifyShipResponse
} from '~/lib/api/smartsend/types';
import { ProviderGroup } from '../../../../lib/helpers/SmartSendBulkActionApplier';
import ProviderGroupSummaryIdle from './ProviderGroupSummaryIdle';
import ProviderGroupSummaryBooking from './ProviderGroupSummaryBooking';
import ProviderGroupSummaryError from './ProviderGroupSummaryError';
import ProviderGroupSummaryBooked from './ProviderGroupSummaryBooked';
import ProviderGroupSummaryStaged from './ProviderGroupSummaryStaged';

interface props {
  group: ProviderGroup;
  updateSelectedPaymentOption: (option: PaymentOptionType, optionOption: PaymentOptionOptionApiModel) => void;
  updateDiscountCode: (discountCode: string) => void;
  markAsDispatched: () => void;
  onBooked: () => void;
  close: () => void;
  removeItems: (ids: string[]) => void;
  paymentOptions: PaymentOptionApiModel[];
  confirmComponent: React.ReactNode;
  verifyShip: (group: ProviderGroup) => Promise<VerifyShipResponse>;
}

const ProviderGroupSummaryContent: React.FC<props> = (props) => {
  switch (props.group.State) {
    case 'IDLE':
      return (
        <ProviderGroupSummaryIdle
          verifyShip={props.verifyShip}
          close={props.close}
          group={props.group}
          paymentOptions={props.paymentOptions}
          updateSelectedPaymentOption={props.updateSelectedPaymentOption}
          updateDiscountCode={props.updateDiscountCode}
        />
      );
    case 'BOOKING':
      return <ProviderGroupSummaryBooking paymentOption={props.group.SelectedPaymentMethod} />;
    case 'ERROR':
      return <ProviderGroupSummaryError removeItems={props.removeItems} group={props.group} />;
    case 'BOOKED':
      return (
        <ProviderGroupSummaryBooked
          group={props.group}
          markAsDispatched={props.markAsDispatched}
          confirmComponent={props.confirmComponent}
        />
      );
    case 'STAGED':
      return (
        <ProviderGroupSummaryStaged
          onAllTrackingNumbersGenerated={props.onBooked}
          group={props.group}
          markAsDispatched={props.markAsDispatched}
        />
      );
    default:
      return null;
  }
};

export default ProviderGroupSummaryContent;
